import styled from 'styled-components'

const StyledModulePreviewSection = styled.div`
  .module-heading {
    height: 50px;
    padding: 0 1rem;
    background-color: ${({ theme }) => theme.colors.gray[100]};
    border-radius: 3px;
    margin-bottom: 18px;
    display: flex;
    align-items: center;

    h3 {
      font-family: ${({ theme }) => theme.fonts.lexend};
      font-weight: 500;
      font-size: 15px;
      color: ${({ theme }) => theme.colors.gray[700]};
    }
  }

  &:not(:last-child) {
    margin-bottom: 40px;
  }
`

export default StyledModulePreviewSection
